import { useIsNinetailedEnabled } from '@lib/ninetailed'
import { NinetailedRenderer } from '@lib/ninetailed/renderer'
import { isUnresolvedLink } from '@lib/utils/contentful-entry'
import { BaseContentfulEntry, BuildContentRendererType, GenericContentRendererProps } from './types'

export const buildContentRenderer: BuildContentRendererType = (contentTypeMap) => {
  const ComponentRenderer = (structure: BaseContentfulEntry) => {
    const contentTypeId = structure.sys.contentType?.sys.id
    const Component = contentTypeMap[contentTypeId]
    if (!Component) {
      console.warn(`${contentTypeId} cannot be handled`)
      return null
    }
    return <Component structure={structure} />
  }

  const ArrayRenderer = ({ structures }: { structures: BaseContentfulEntry[] }) => (
    <>
      {structures
        .filter((s) => !isUnresolvedLink(s))
        .map((s) => (
          <GenericContentRenderer key={`${s.sys.contentType.sys.id}-${s.sys.id}`} structure={s} />
        ))}
    </>
  )

  const GenericContentRenderer = ({ structure }: GenericContentRendererProps) => {
    const isNinetailedEnabled = useIsNinetailedEnabled()

    if (!structure) {
      return null
    }

    if (Array.isArray(structure)) {
      return <ArrayRenderer structures={structure} />
    }

    if (isNinetailedEnabled) {
      return <NinetailedRenderer structure={structure} renderer={ComponentRenderer} />
    }

    return ComponentRenderer(structure)
  }

  return GenericContentRenderer
}
